import { createRoot } from "react-dom/client";
import { StoreProvider } from "@/app/storeProvider";
import React from "react";
import CarCompetition from "../app/(custom-header)/prizes/car-v2/page";

const root = createRoot(document.getElementById("supercar-page") as HTMLElement);

root.render(
  <React.StrictMode>
    <StoreProvider>
      <CarCompetition />
    </StoreProvider>
  </React.StrictMode>
);
